import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ILookupCategory } from '../../../shared/models/lookup.model';
import { CompanyDocumentType, LookupCategory, MSAType } from '../../../shared/enums/EnumsVMS';
import { SharedService } from '../../../shared/services';
import { VendorOnboardApprovalViewService } from '../../../admin/services/vendor-onboard-approval-view.service'
import { User } from '../../../auth/models/user.model';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CompanyService } from '../../../users/services';
import { VMSConstants } from '../../../shared/constants/vms-constants';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DocViewerDialogComponent } from '../../../doc-viewer/doc-viewer-dialog/doc-viewer-dialog.component';
import { JwtService } from '../../../auth/services';
import { ActivatedRoute, Router } from '@angular/router';
import { BackToSearchService } from '../../../shared/services/back-to-search.service';
import { IVendorOnboardingApprovalView } from '../../models/venodor-onboarding-approval-view.model'
import { RegisterService } from 'src/app/auth/services/register.service';

@Component({
  selector: 'app-vendor-onboard-approval-view',
  templateUrl: './vendor-onboard-approval-view.component.html',
  styleUrls: ['./vendor-onboard-approval-view.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, MessageService, ConfirmationService],
})
export class VendorOnboardApprovalViewComponent implements OnInit {
  vendorName: string;
  entitytype;
  taxIdNumber;
  vendorEmailId;
  webAddress;
  vendorPhoneNumber;
  vendorPhoneExtNumber;
  faxNumber;
  addressLine1;
  addressLine2;
  stateName;
  city;
  zipCode;
  zipCodeExt;
  paymentTerms;
  distributionEmail;
  invoiceTerms;
  msaType;
  insuranceExhibit;
  vendorCategory;
  firstName;
  middleName;
  lastName;
  adminEmailId;
  adminPhone;
  extNumber;
  ssnNumber;
  entityTypes: ILookupCategory;
  public selectedEntityTypeId: Array<any> = [];
  categoryName;
  vendorId;
  loggedInUserProfile: User;
  companyCOIDetailsUpdateForm: FormGroup;
  backToSearchData = null;
  @ViewChild('generalLiablityEffDate') gLEffDatepicker;
  @ViewChild('generalLiablityExpDate') gLExpDatepicker;
  @ViewChild('automobileLiabilityEffDate') aLEffDatepicker;
  @ViewChild('automobileLiablityExpDate') aLExpDatepicker;
  @ViewChild('umbrellaLiablityEffDate') uLEffDatepicker;
  @ViewChild('umbrellaLiabilityExpDate') uLExpDatepicker;
  @ViewChild('workersCompensationEffDate') wCEffDatepicker;
  @ViewChild('workersCompensationExpDate') wCExpDatepicker;
  @ViewChild('professtionalLiabilityEffDate') pLEffDatepicker;
  @ViewChild('PrefessionalLiabilityExpDate') pLExpDatepicker;
  documentRejectionModel: boolean = false;
  entityTypeId: number;
  isVendorApproved: boolean;
  msaTypeId: any;
  insuranceExhibitId: any;
  commentsFormControl = new FormControl("", [Validators.required, this.editorMaxLength(10000)]);
  rejectionPopUpModel = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }]
    ]
  }
  header:string="";
  isVendorAvailable:boolean = false;
  isMSASelected: boolean = false;
  isPOSelected: boolean = false;
  isNCASelected: boolean = false;
  isVoidChequeSelected: boolean = false;
  isW9Selected: boolean = false;
  isI9Selected: boolean = false;
  isDDSelected: boolean = false;
  isCOISelected: boolean = false;
  isEVerificationSelected: boolean = false;
  existingvendorId:number;
  isMSARejected: boolean = false;
  isPORejected: boolean = false;
  isNCARejected: boolean = false;
  vendorApprovalViewTitle:string;
  vendorApprovalViewHeader:string;
  isProcessOnboard:boolean=false;
  constructor(private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private vendorOnboardApprovalViewService: VendorOnboardApprovalViewService,
    private spinner: NgxSpinnerService,
    private companyService: CompanyService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private jwtService: JwtService,
    private route: ActivatedRoute,
    private router: Router,
    private backToSearchService: BackToSearchService,
    private confirmationService: ConfirmationService,
    private registerService:RegisterService
  ) { }

  ngOnInit(): void {
    window.scroll(0, 0);
    this.backToSearchService.getBackToSearchSharedData().subscribe(data => this.backToSearchData = data);
this.spinner.show();
    //this.vendorName = "My Vendor Name"
        this.getEntityType();
    this.getLoggedInUserProfile();
    this.companyCOIDetailsForm();
    this.checkViewPermission();
    const param = this.route.snapshot.paramMap.get('tempVendorId');
    if (param) {
      this.vendorId = param;
      this.GetOnboardProcessDetailsMSPView();

    }
}
    companyCOIDetailsForm() {
        this.companyCOIDetailsUpdateForm = this.formBuilder.group({
      glEffDate: [''],
      glExpDate: [''],
      alEffDate: [''],
      alExpDate: [''],
      ulEffDate: [''],
      ulExpDate: [''],
      wcEffDate: [''],
      wcExpDate: [''],
      plEffDate: [''],
      plExpDate: [''],
      comments: []
    });
  } closeCOIRequestDialog() {
    this.companyCOIDetailsForm();

    this.gLEffDatepicker.overlayVisible = false;
    this.gLExpDatepicker.overlayVisible = false;
    this.aLEffDatepicker.overlayVisible = false;
    this.aLExpDatepicker.overlayVisible = false;
    this.uLEffDatepicker.overlayVisible = false;
    this.uLExpDatepicker.overlayVisible = false;
    this.wCEffDatepicker.overlayVisible = false;
    this.wCExpDatepicker.overlayVisible = false;
    this.pLEffDatepicker.overlayVisible = false;
    this.pLExpDatepicker.overlayVisible = false;

  }
  editorMaxLength(maxlength): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      var regex = /(<([^>]+)>)/ig;
      var value = control.value;
      if (value == null) {
        return null;
      }
      var result = value.replace(regex, "");
      if (result.length > maxlength) {
        return { 'maxlengthError': true };
      } else {
        return null;
      }
    }
  }
  getLoggedInUserProfile() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }
  getEntityTypeOnChange(event) {
    this.entityTypeId = event.value.lookupId;
  }
  getEntityType() {
    this.categoryName = 'Entity Type'
    this.sharedService.getLookupCategory(this.categoryName).subscribe((data: any) => {
      this.entityTypes = data;
      this.arrEntityType = data;
      //this.entityTypes = data.filter(item => item.description !== 'Individual');
    });
  }
  arrEntityType;
  isEntityType: boolean = false;
  showMSAFormFilePreviewEnable: boolean = false;
  showPOFormFilePreviewEnable: boolean = false;
  showNCAFormFilePreviewEnable: boolean = false;
  showCOIFormFilePreviewEnable: boolean = false;
  showDDFormFilePreviewEnable: boolean = false;
  showVoidChequeFormFilePreviewEnable: boolean = false;
  showW9FormFilePreviewEnable: boolean = false;
  showI9FormFilePreviewEnable: boolean = false;
  showEVerificationFormFilePreviewEnable: boolean = false;
  msaFileName: string;
  poFileName: string;
  ncaFileName: string;
  coiFileName: string;
  ddFileName: string;
  voidChequeFileName: string;
  w9FileName: string;
  i9FileName: string;
  eVerificationFileName: string;
  w9FileDocUrl: string = "";
  ddFileDocUrl: string = "";
  coiFileDocUrl: string = "";
  msaFileDocUrl: string = "";
  poFileDocUrl: string = "";
  ncaFileDocUrl: string = "";
  i9FileDocUrl: string = "";
  voidChequeFileDocUrl: string = "";
  eVerificationFileDocUrl: string = "";
  msaDocumentFileName: string;
  poDocumentFileName: string;
  ncaDocumentFileName: string;
  coiDocumentFileName: string;
  ddDocumentFileName: string;
  voidChequeDocumentFileName: string;
  w9DocumentFileName: string;
  i9DocumentFileName: string;
  eVerificationDocumentFileName: string;
  isNCADoc: boolean = false;
  isEVerificationDoc: boolean = false;
  isCOIRejected: boolean = false;
  isDDRejected: boolean = false;
  isVoidChequeRejected: boolean = false;
  isW9Rejected: boolean = false;
  isI9Rejected: boolean = false;
  isEVerificationRejected: boolean = false;
  isMSAVerificationRejected: boolean = false;
  isPOVerificationRejected: boolean = false;
  isNCAVerificationRejected: boolean = false;
  stateId: number;
  invoiceTermsId: number;
  vendorCategoryId: number;
  paymentTermsId: number;
  emailLinkRefId: string;
  isMSAType1099:boolean=false;
  GetOnboardProcessDetailsMSPView() {
    this.vendorOnboardApprovalViewService.OnboardProcessDetailsMSPView(this.vendorId, Number(this.loggedInUserProfile.uid)).subscribe((data: any) => {
      console.log('view vendor info data', data);
      this.vendorName = data.vendorName;
      this.taxIdNumber = data.taxIdNumber;
      this.ssnNumber=data.ssnNumber;
      this.vendorEmailId = data.primaryEmail;
      this.vendorPhoneNumber = data.primaryPhone;
      this.entitytype = data.entitytype;
      this.vendorPhoneExtNumber = data.primaryPhoneExt;
      this.faxNumber = data.faxNumber;
      this.webAddress = data.website;
      this.addressLine1 = data.addressLine1;
      this.addressLine2 = data.addressLine2;
      this.stateName = data.stateName;
      this.city = data.city;
      this.zipCode = data.zipCode;
      this.zipCodeExt = data.zipCodeExt;
      this.paymentTerms = data.paymentTerms;
      this.invoiceTerms = data.invoiceTerms;
      this.vendorCategory = data.vendorCategory;
      this.msaType = data.msaType;
      this.insuranceExhibit = data.insuranceExhibit;
      this.firstName = data.vendorAdminFirstName;
      this.middleName = data.vendorAdminMiddleName;
      this.lastName = data.vendorAdminLastName;
      this.adminPhone = data.vendorAdminPhone;
      this.adminEmailId = data.vendorAdminEmail;
      this.extNumber = data.vendorAdminPhoneExt;
      this.stateId = data.stateId;
      this.invoiceTermsId = data.invoiceTermsId;
      this.vendorCategoryId = data.vendorCategoryId;
      this.paymentTermsId = data.paymentTermsId;
      this.emailLinkRefId = data.emailLinkRefId;
      this.isVendorApproved = data.isApproved;
      this.msaTypeId = data.msaTypeId;
      this.insuranceExhibitId = data.insuranceExhibitId;
      this.existingvendorId= data.vendorId;
      this.isVendorAvailable=data.isVendorAvailable;
      this.isMSASelected = data.isMSASelected;
      this.isPOSelected = data.isPOSelected;
      this.isNCASelected = data.isNCASelected;
      this.isVoidChequeSelected =data.isVoidChequeSelected;
      this.isW9Selected = data.isW9Selected;
      this.isI9Selected = data.isI9Selected;
      this.isDDSelected = data.isDDSelected;
      this.isCOISelected = data.isCOISelected;
      this.isEVerificationSelected = data.isEVerificationSelected;
      this.companyCOIDetailsUpdateForm = this.formBuilder.group({
        glEffDate: [data.coiDocumentDetails.glEffDate == null ? null : new Date(data.coiDocumentDetails.glEffDate)],
        glExpDate: [data.coiDocumentDetails.glExpDate == null ? null : new Date(data.coiDocumentDetails.glExpDate)],
        alEffDate: [data.coiDocumentDetails.alEffDate == null ? null : new Date(data.coiDocumentDetails.alEffDate)],
        alExpDate: [data.coiDocumentDetails.alExpDate == null ? null : new Date(data.coiDocumentDetails.alExpDate)],
        ulEffDate: [data.coiDocumentDetails.ulEffDate == null ? null : new Date(data.coiDocumentDetails.ulEffDate)],
        ulExpDate: [data.coiDocumentDetails.ulExpDate == null ? null : new Date(data.coiDocumentDetails.ulExpDate)],
        wcEffDate: [data.coiDocumentDetails.wcEffDate == null ? null : new Date(data.coiDocumentDetails.wcEffDate)],
        wcExpDate: [data.coiDocumentDetails.wcExpDate == null ? null : new Date(data.coiDocumentDetails.wcExpDate)],
        plEffDate: [data.coiDocumentDetails.plEffDate == null ? null : new Date(data.coiDocumentDetails.plEffDate)],
        plExpDate: [data.coiDocumentDetails.plExpDate == null ? null : new Date(data.coiDocumentDetails.plExpDate)],
        comments: []
      });
      // this.companyService.getEntityType(data.entityTypeId).subscribe((data: any) => {
      //   this.selectedEntityTypeId = data;
      //   // this.entityTypeEdit = data.description;
      //   // this.entityTypeId = value.entityTypeId;
      //   // this.getEntityTypeOnChangeEdit();
      // });
      if (data.msaTypeId == MSAType.Special1099 || data.msaTypeId == MSAType.Standard1099) {
        //this.isNCADoc = true;
        this.isEVerificationDoc = false;
        this.isMSAType1099=true;
      }
      else {
        //this.isNCADoc = false;
        this.isEVerificationDoc = true;
        this.isMSAType1099=false;
      }
      if (data.entityTypeId != null && data.entityTypeId != undefined) {
        var arr = this.arrEntityType.filter(item => item.lookupId == data.entityTypeId);
        this.selectedEntityTypeId = arr[0];
        this.isEntityType = true;
        this.entityTypeId = arr[0].lookupId;

      }
      if(data.msaDocumentDetails != null && data.msaDocumentDetails != undefined && data.msaDocumentDetails !=''){
      if (data.msaDocumentDetails.documentFileName == undefined || data.msaDocumentDetails.documentFileName == null || data.msaDocumentDetails.documentFileName == '') {
        //this.msaValid = true;
        this.showMSAFormFilePreviewEnable = false;
        this.isMSARejected=true;
      }
      else {
        //this.msaValid = false;
        this.showMSAFormFilePreviewEnable = true;
        this.msaFileName = data.msaDocumentDetails.azureURL;
        this.msaDocumentFileName = data.msaDocumentDetails.documentFileName;
        this.msaFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.msaDocumentFileName;
        this.isMSARejected=data.msaDocumentDetails.isRejected;
        //this.getMSAFile(this.msaFileName);
      }
    }
    else{
      if(this.isVendorAvailable && !this.isMSASelected)
        {
          this.isMSARejected=false;
        }
        else{
          this.isMSARejected=true;
        }
    }
    if(data.poDocumentDetails != null && data.poDocumentDetails != undefined && data.poDocumentDetails !=''){
      if (data.poDocumentDetails.documentFileName == undefined || data.poDocumentDetails.documentFileName == null || data.poDocumentDetails.documentFileName == '') {
        this.showPOFormFilePreviewEnable = false;
        this.isPORejected=true;
      }
      else {
        this.showPOFormFilePreviewEnable = true;
        this.poFileName = data.poDocumentDetails.azureURL;
        this.poDocumentFileName = data.poDocumentDetails.documentFileName;
        this.poFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.poDocumentFileName;
        this.isPORejected=data.poDocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isPOSelected)
        {
          this.isPORejected=false;
        }
        else{
          this.isPORejected=true;
        }
    }
    if(data.ncaDocumentDetails != null && data.ncaDocumentDetails != undefined && data.ncaDocumentDetails !=''){
      if (data.ncaDocumentDetails.documentFileName == undefined || data.ncaDocumentDetails.documentFileName == null || data.ncaDocumentDetails.documentFileName == '') {
        this.showNCAFormFilePreviewEnable = false;
        this.isNCARejected=true;
      }
      else {
        this.showNCAFormFilePreviewEnable = true;
        this.ncaFileName = data.ncaDocumentDetails.azureURL;
        this.ncaDocumentFileName = data.ncaDocumentDetails.documentFileName;
        this.ncaFileDocUrl =VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.ncaDocumentFileName;
        this.isNCARejected=data.ncaDocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isNCASelected)
      {
        this.isNCARejected=false;
      }
      else{
        if(this.isVendorAvailable &&this.isNCASelected && (this.msaTypeId== MSAType.Standard1099 ||this.msaTypeId== MSAType.Special1099))
        {
          this.isNCARejected=true;
        }
        else{
          this.isNCARejected=false;
        }
      }
    }
    if(data.coiDocumentDetails != null && data.coiDocumentDetails != undefined && data.coiDocumentDetails !=''){
      if (data.coiDocumentDetails.insuranceFileUrl == undefined || data.coiDocumentDetails.insuranceFileUrl == null || data.coiDocumentDetails.insuranceFileUrl == '') {
        this.showCOIFormFilePreviewEnable = false;
        if(this.isVendorAvailable && !this.isCOISelected)
          {
            this.isCOIRejected=false;
          }
          else{
            this.isCOIRejected=true;
          }
       // this.isCOIRejected=true;
      }
      else {
        this.showCOIFormFilePreviewEnable = true;
        this.coiFileName = data.coiDocumentDetails.azureURL;
        this.coiDocumentFileName = data.coiDocumentDetails.insuranceFileUrl;
        this.coiFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.coiDocumentFileName;
        this.isCOIRejected=data.coiDocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isCOISelected)
      {
        this.isCOIRejected=false;
      }
      else{
        this.isCOIRejected=true;
      }
    }
    if(data.ddDocumentDetails != null && data.ddDocumentDetails != undefined && data.ddDocumentDetails !=''){
      if (data.ddDocumentDetails.documentFileName == undefined || data.ddDocumentDetails.documentFileName == null || data.ddDocumentDetails.documentFileName == '') {
        this.showDDFormFilePreviewEnable = false;
        this.isDDRejected=true;
      }
      else {
        this.showDDFormFilePreviewEnable = true;
        this.ddFileName = data.ddDocumentDetails.azureURL;
        this.ddDocumentFileName = data.ddDocumentDetails.documentFileName;
        this.ddFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.ddDocumentFileName;
        this.isDDRejected=data.ddDocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isDDSelected)
        {
          this.isDDRejected=false;
        }
        else{
          this.isDDRejected=true;
        }
    }
    if(data.voidChequeDocumentDetails != null && data.voidChequeDocumentDetails != undefined && data.voidChequeDocumentDetails !=''){
      if (data.voidChequeDocumentDetails.documentFileName == undefined || data.voidChequeDocumentDetails.documentFileName == null || data.voidChequeDocumentDetails.documentFileName == '') {
        this.showVoidChequeFormFilePreviewEnable = false;
        this.isVoidChequeRejected=true;
      }
      else {
        this.showVoidChequeFormFilePreviewEnable = true;
        this.voidChequeFileName = data.voidChequeDocumentDetails.azureURL;
        this.voidChequeDocumentFileName = data.voidChequeDocumentDetails.documentFileName;
        this.voidChequeFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.voidChequeDocumentFileName;
        this.isVoidChequeRejected=data.voidChequeDocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isVoidChequeSelected)
        {
          this.isVoidChequeRejected=false;
        }
        else{
          this.isVoidChequeRejected=true;
        }
    }
    if(data.w9DocumentDetails != null && data.w9DocumentDetails != undefined && data.w9DocumentDetails !=''){
      if (data.w9DocumentDetails.documentFileName == undefined || data.w9DocumentDetails.documentFileName == null || data.w9DocumentDetails.documentFileName == '') {
        this.showW9FormFilePreviewEnable = false;
        this.isW9Rejected=true;
      }
      else {
        this.showW9FormFilePreviewEnable = true;
        this.w9FileName = data.w9DocumentDetails.azureURL;
        this.w9DocumentFileName = data.w9DocumentDetails.documentFileName;
        this.w9FileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.w9DocumentFileName;
        this.isW9Rejected=data.w9DocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isW9Selected)
        {
          this.isW9Rejected=false;
        }
        else{
          this.isW9Rejected=true;
        }
    }
    if(data.i9DocumentDetails != null && data.i9DocumentDetails != undefined && data.i9DocumentDetails !=''){
      if (data.i9DocumentDetails.documentFileName == undefined || data.i9DocumentDetails.documentFileName == null || data.i9DocumentDetails.documentFileName == '') {
        this.showI9FormFilePreviewEnable = false;
        this.isI9Rejected=true;
      }
      else {
        this.showI9FormFilePreviewEnable = true;
        this.i9FileName = data.i9DocumentDetails.azureURL;
        this.i9DocumentFileName = data.i9DocumentDetails.documentFileName;
        this.i9FileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.i9DocumentFileName;
        this.isI9Rejected=data.i9DocumentDetails.isRejected;
      }
    }
    else{
      if(this.isVendorAvailable && !this.isI9Selected)
        {
          this.isI9Rejected=false;
        }
        else{
          this.isI9Rejected=true;
        }
    }
    if(data.eVerificationDocumentDetails != null && data.eVerificationDocumentDetails != undefined && data.eVerificationDocumentDetails !=''){
      if (data.eVerificationDocumentDetails.documentFileName == undefined || data.eVerificationDocumentDetails.documentFileName == null || data.eVerificationDocumentDetails.documentFileName == '') {
        this.showEVerificationFormFilePreviewEnable = false;
        if(this.isEVerificationDoc)
        {
          if(this.isVendorAvailable && !this.isEVerificationSelected)
            {
              this.isEVerificationRejected=false;
            }
            else{
              this.isEVerificationRejected=true;
            }
        }
      
    else  this.isEVerificationRejected=false;
      }
      else {
        this.showEVerificationFormFilePreviewEnable = true;
        this.eVerificationFileName = data.eVerificationDocumentDetails.azureURL;
        this.eVerificationDocumentFileName = data.eVerificationDocumentDetails.documentFileName;
        this.eVerificationFileDocUrl = VMSConstants.vendorOnboardingDocumentBaseUrl+this.emailLinkRefId+'/' + this.eVerificationDocumentFileName;
        if(this.isEVerificationDoc)
          this.isEVerificationRejected=data.eVerificationDocumentDetails.isRejected;
        else  this.isEVerificationRejected=false;
      }
    }
    else{
      if(this.isEVerificationDoc)

        {
          if(this.isVendorAvailable && !this.isEVerificationSelected)
            {
              this.isEVerificationRejected=false;
            }
            else{
              this.isEVerificationRejected=true;
            }
        }
    else  this.isEVerificationRejected=false;
    }
    if(this.isVendorAvailable)
    {
       this.vendorApprovalViewTitle="Vendor Documents Approval";
       this.vendorApprovalViewHeader="Vendor Documents Approval View";
    }
    else{
      this.vendorApprovalViewTitle="Vendor Onboard Approval";
       this.vendorApprovalViewHeader="Vendor Onboard Approval View";
    }
      this.spinner.hide();
    });
  }
  getMSAFile(fileURL) {
    if (this.msaFileName.includes("CompanyDocument") == true) {
      this.msaFileDocUrl = VMSConstants.companyDocumentBaseUrl + this.msaFileName;
    }
    else {
      this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.msaFileName;
    }
    // this.msaFileDocUrl = VMSConstants.registrationDocumentBaseUrl + this.msaFileName;
  }

  ShowUploadedFile(documentFileName, fileDocUrl,DocumentName) {
    console.log(fileDocUrl);
    if (documentFileName != null) {
      if (documentFileName.split('.').pop() == 'gif' || documentFileName.split('.').pop() == 'png' || documentFileName.split('.').pop() == 'jpeg' || documentFileName.split('.').pop() == 'jpg') {
        const ref = this.dialogService.open(DocViewerDialogComponent, {
          data: {
            fileUrl: fileDocUrl,
            title: DocumentName,
            fileName: documentFileName,
          },
          width: '100%',
          height: '100%',
          baseZIndex: 10000,
          showHeader: false,
        });
      }
      else {
        const ref = this.dialogService.open(DocViewerDialogComponent, {
          data: {
            fileUrl: fileDocUrl,
            title:DocumentName,
            fileName: fileDocUrl,
          },
          width: '100%',
          height: '100%',
          baseZIndex: 10000,
          showHeader: false,
        });
      }
    }
    else {
      const ref = this.dialogService.open(DocViewerDialogComponent, {
        data: {
          fileUrl: fileDocUrl,
          title: DocumentName,
          fileName: fileDocUrl,
        },
        width: '100%',
        height: '100%',
        baseZIndex: 10000,
        showHeader: false,
      });
    }
  }
  isComment:boolean=false;
  updateCompanyCOIDetails({ value }: { value: any }) {
    this.registerService.onVendorEmailCheck(this.adminEmailId).subscribe((data: any) => {
      this.isProcessOnboard= data;
      console.log('ppob',this.isProcessOnboard);
      if(this.isProcessOnboard == false)
        {
          var currentDate = new Date();
        if ((new Date(value.glExpDate) < new Date(currentDate) || new Date(value.alExpDate) < new Date(currentDate) || new Date(value.ulExpDate) < new Date(currentDate)
          || new Date(value.wcExpDate) < new Date(currentDate) || new Date(value.plExpDate) < new Date(currentDate)) && this.showCOIFormFilePreviewEnable== true) {
          this.confirmationService.confirm({
            key: 'COIUpdateConfirm',
            //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
            message: '<center> Some insurance(s) are having an expired date/not having the Eff. and Exp. dates. Approving the COI with invalid dates will affect the COI expiry alerts and the invoices. Would you like to approve the COI with expired dates/without Eff. and Exp. dates? </center>',
            accept: () => {
              if (this.isMSARejected ||this.isPORejected ||this.isNCARejected ||this.isCOIRejected || this.isDDRejected || this.isVoidChequeRejected || this.isW9Rejected || this.isI9Rejected || this.isEVerificationRejected) {
                this.documentRejectionModel = true;
                this.header="Approve with document rejection - "+this.vendorName
                this.commentsFormControl.setValidators([Validators.required, this.editorMaxLength(10000)]);;
                this.commentsFormControl.updateValueAndValidity();
                this.isComment=true;
                return;
              }
              else {
                //this.saveVendorOnboardView(this.companyCOIDetailsUpdateForm);
    
                this.commentsFormControl.clearValidators();
                this.commentsFormControl.updateValueAndValidity();
                this.documentRejectionModel = true;
                this.header="Approve - "+this.vendorName
                this.isComment=false;
              }
            },
            reject: () => {
    
            }
          });
    
        }
        else {
          if (this.isMSARejected ||this.isPORejected ||this.isNCARejected ||this.isCOIRejected || this.isDDRejected || this.isVoidChequeRejected || this.isW9Rejected || this.isI9Rejected || this.isEVerificationRejected) {
           
          //  console.log(this.isMSARejected);
          //  console.log(this.isPORejected);
          //  console.log(this.isNCARejected);
          //  console.log(this.isCOIRejected);
          //  console.log(this.isDDRejected);
          //  console.log(this.isVoidChequeRejected);
          //  console.log(this.isW9Rejected);
          //  console.log(this.isI9Rejected);
          //  console.log(this.isEVerificationRejected);
            this.documentRejectionModel = true;
            this.header="Approve with document rejection - "+this.vendorName
            this.commentsFormControl.setValidators([Validators.required, this.editorMaxLength(10000)]);;
            this.commentsFormControl.updateValueAndValidity();
            this.isComment=true;
            return;
          }
          else {
            this.documentRejectionModel = true;
            this.header="Approve - "+this.vendorName
            this.commentsFormControl.clearValidators();
            this.commentsFormControl.updateValueAndValidity();
            this.isComment=false;
            return;
            //this.saveVendorOnboardView(this.companyCOIDetailsUpdateForm);
          }
        }
        }
        else{
          //console.log('in');
          this.spinner.hide();
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Admin email is already exists' })
        }
    });
   
  }
  saveVendorOnboardView({ value }: { value: any }) {

    this.spinner.show();
    const vendorOnboardDetails: IVendorOnboardingApprovalView = {
      tempVendorId: this.vendorId,
      CreatedBy: Number(this.loggedInUserProfile.uid),
      ModifiedBy: Number(this.loggedInUserProfile.uid),
      stateId: this.stateId,
      coiDocumentDetails: { glEffDate: value.glEffDate, glExpDate: value.glExpDate, alEffDate: value.alEffDate, alExpDate: value.alExpDate, ulEffDate: value.ulEffDate, ulExpDate: value.ulExpDate, wcEffDate: value.wcEffDate, wcExpDate: value.wcExpDate, plEffDate: value.plEffDate, plExpDate: value.plExpDate, insuranceFileUrl: this.coiFileName ,isApproved: this.isCOIRejected ? false : true  },
      vendorCategoryId: this.vendorCategoryId,
      paymentTermsId: this.paymentTermsId,
      invoiceTermsId: this.invoiceTermsId,
      isApproved: true,
      ddDocumentDetails: { isApproved: this.isDDRejected ? false : true },
      voidChequeDocumentDetails: { isApproved: this.isVoidChequeRejected ? false : true },
      w9DocumentDetails: { isApproved: this.isW9Rejected ? false : true },
      i9DocumentDetails: { isApproved: this.isI9Rejected ? false : true },
      eVerificationDocumentDetails: { isApproved: this.isEVerificationRejected ? false : true },
      msaDocumentDetails: { isApproved: this.isMSARejected ? false : true },
      poDocumentDetails: { isApproved: this.isPORejected ? false : true },
      ncaDocumentDetails: { isApproved: this.isNCARejected ? false : true },
      vendorAdminEmail: this.adminEmailId,
      isVendorAvailable:this.isVendorAvailable,
      isMSASelected:this.isMSASelected,
      isPOSelected:this.isPOSelected,
      isNCASelected:this.isNCASelected,
      isVoidChequeSelected:this.isVoidChequeSelected,
      isW9Selected:this.isW9Selected,
      isI9Selected:this.isI9Selected,
      isDDSelected:this.isDDSelected,
      isCOISelected:this.isCOISelected,
      isEVerificationSelected:this.isEVerificationSelected,
      rejectedReason: this.commentsFormControl.value,
      emailLinkRefId: this.emailLinkRefId,
      entityTypeId: this.entityTypeId,
      msaTypeId: this.msaTypeId,
      insuranceExhibitId: this.insuranceExhibitId,
      vendorId:this.existingvendorId,
      taxIdNumber:this.taxIdNumber,
      ssnNumber:this.ssnNumber,
    };
    this.vendorOnboardApprovalViewService.ApproveVendorOnboardProcessDetailsByMSP(vendorOnboardDetails).subscribe((data: any) => {
      this.documentRejectionModel=false;
      this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'The vendor: ' + this.vendorName + ' has been onboarded successfully' })
      setTimeout(()=>{ 
        this.spinner.hide();
          if (this.backToSearchData != null && this.backToSearchData.fromPage == 'Vendor Onboard Process Search Page') {
        this.backToSearchData.fromPage = 'Vendor Onboard Approval View Page';
        this.backToSearchData.toPage = 'Vendor Onboard Process Search Page';
        this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
        this.router.navigate(['/admin/vendor-onboard-process-search']);
      }
      else if (this.backToSearchData != null && this.backToSearchData.fromPage == 'Vendor Onboard Approval Search Page') {
        this.backToSearchData.fromPage = 'Vendor Onboard Approval View Page';
        this.backToSearchData.toPage = 'Vendor Onboard Approval Search Page';
        this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
        this.router.navigate(['/admin/vendor-onboard-approval-search']);
      }
      else{
        this.router.navigate(['/admin/vendor-onboard-approval-search']);
      }
    }, 2000);
      this.spinner.hide();
    });
  }
  cancel() {
    if (this.backToSearchData != null && this.backToSearchData.fromPage == 'Vendor Onboard Process Search Page') {
      this.backToSearchData.fromPage = 'Vendor Onboard Approval View Page';
      this.backToSearchData.toPage = 'Vendor Onboard Process Search Page';
      this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
      this.router.navigate(['/admin/vendor-onboard-process-search']);
    }
    else if (this.backToSearchData != null && this.backToSearchData.fromPage == 'Vendor Onboard Approval Search Page') {
      this.backToSearchData.fromPage = 'Vendor Onboard Approval View Page';
      this.backToSearchData.toPage = 'Vendor Onboard Approval Search Page';
      this.backToSearchService.setBackToSearchSharedData(this.backToSearchData);
      this.router.navigate(['/admin/vendor-onboard-approval-search']);
    }
    else{
      this.router.navigate(['/admin/vendor-onboard-approval-search']);
    }
  }
  OnMSAVerificationCheckBoxChange(value) {
    this.isMSARejected = value.checked;
  }
  OnPOVerificationCheckBoxChange(value) {
    this.isPORejected = value.checked;
  }
  OnNCAVerificationCheckBoxChange(value) {
    this.isNCARejected = value.checked;
  }
  OnEVerificationCheckBoxChange(value) {
    this.isEVerificationRejected = value.checked;
  }
  OnCOICheckBoxChange(value) {
    this.isCOIRejected = value.checked;
  }
  OnDDCheckBoxChange(value) {
    this.isDDRejected = value.checked;
  }
  OnVoidChequeCheckBoxChange(value) {
    this.isVoidChequeRejected = value.checked;
  }
  OnW9CheckBoxChange(value) {
    this.isW9Rejected = value.checked;
  }
  OnI9CheckBoxChange(value) {
    this.isI9Rejected = value.checked;
  }
  checkViewPermission() {
    var permission = this.jwtService.getLoggedInUserProfile();
    if (permission == 0) {
      this.router.navigateByUrl('/login');
    }
  }
  onCancelRejectionPopUp() {
    this.documentRejectionModel = false;
    this.commentsFormControl.setValue('');
  }

  reApproveCompanyDocumentDetails(documentType)
  {
    this.confirmationService.confirm({
      key:'COIUpdateConfirm',
      header:"Confirm Document Re-approve",
      message :'<center>Re-approving this document will replace the existing document in the vendor company profile. Please re-verify the existing document in the vendor company profile before re-approving it.</center><br/><center>Would you like to re-approve this document?</center>',
     //message: '<center>Please verify the email entered on the company profile is</center><center>'+' '+this.emailId.bold()+'.</center><center> You cannot change this email address after the save.</center><center>Select <strong>YES</strong> to continue or <strong>NO </strong>to go back and edit the email address',
     //message: '<center> Some insurance(s) are having an expired date. Would you like to approve the COI update request with expired dates? </center>',
     accept: () => {

      //this.documnetReApproveDetailsDialog=false;
      let value={
        documentTypeId:'',
        emailLinkRefId:this.emailLinkRefId,
        tempVendorId:this.vendorId,
        modifiedOn:new Date(),
        modifiedBy:Number(this.loggedInUserProfile.uid),
        isActive:true,
        createdBy:0,
        createdOn:new Date()
      };
      if(documentType=='MSA')
        value.documentTypeId=String(CompanyDocumentType.MSA);
      else if(documentType=='PO')
        value.documentTypeId=String(CompanyDocumentType.PO);
      else if(documentType=='NCA')
        value.documentTypeId=String(CompanyDocumentType.NCA);
      else if(documentType=='DD')
        value.documentTypeId=String(CompanyDocumentType.DD);
      else if(documentType=='I9')
        value.documentTypeId=String(CompanyDocumentType.I9);
      else if(documentType=='W9')
        value.documentTypeId=String(CompanyDocumentType.W9);
      else if(documentType=='E-Verification')
        value.documentTypeId=String(CompanyDocumentType.E_Verification);
      else if(documentType=='Void Cheque')
        value.documentTypeId=String(CompanyDocumentType.Void_Cheque);
      else if(documentType=='COI')
        value.documentTypeId=String(CompanyDocumentType.COI);
      value.emailLinkRefId= this.emailLinkRefId;
      value.tempVendorId =  this.vendorId;
      value.modifiedBy = Number(this.loggedInUserProfile.uid);
      this.vendorOnboardApprovalViewService.reApproveRejectedDocument(value).subscribe((data:any)=>{
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'Document Re-Approved successfully' })
        this.GetOnboardProcessDetailsMSPView();
  
      });

     },
     reject:() =>{
     }});
 
  }
}
